import { NgClass } from '@angular/common';
import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HistoriqueComponent } from '../../historique/historique.component';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatButton } from '@angular/material/button';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'app-redirections-form',
  templateUrl: './redirections-form.component.html',
  styleUrl: './redirections-form.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgClass,
    HistoriqueComponent,
    MatSlideToggle,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatButton,
    MatInput,
  ],
})
export class RedirectionsFormComponent implements OnInit {
  form!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<RedirectionsFormComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      mode: 'view' | 'edit';
      rule: {
        id: string;
        name: string;
        extensionId: string;
        organizationId: string;
        target: string;
        enabled: boolean;
        ringSeconds: number;
      };
    }
  ) {}

ngOnInit(): void {
  this.form = this.fb.group({
    name: [{ value: this.data.rule.name, disabled: true }], // toujours readonly
    extensionId: [{ value: this.data.rule.extensionId, disabled: true }], // toujours readonly
    target: [{ value: this.data.rule.target, disabled: true }], // toujours readonly
    enabled: [
      { value: this.data.rule.enabled, disabled: this.data.mode === 'view' },
      Validators.required
    ],
    ringSeconds: [
      { value: this.data.rule.ringSeconds, disabled: this.data.mode === 'view' },
      [Validators.required, Validators.min(5), Validators.max(60)]
    ]
  });
}

  onSave(): void {
    if (this.form.invalid) {
      return;
    }

    const updatedRule = {
      ...this.data.rule,
      ...this.form.value,
    };

    this.dialogRef.close(updatedRule);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
